

<template>
  <div class="odds-page-wrap" v-if="!isEmpty">
    <div class="table-title">
      <div class="name">全部公司</div>
      <div class="nav-item" v-for="(nav, idx) in navList" :key="`${nav.id}-${idx}`">
        <template v-if="nav.id === 1001">第{{ nav.name | numToCN }}局</template>
        <template v-else>{{ nav.name }}</template>
      </div>
    </div>
    <div class="table-body">
      <div class="odd-item" v-for="(obj, key) in oddsList" :key="`${key}`">
        <div class="name">
          <div class="company">{{ key }}</div>
          <div class="type">
            <div>初始</div>
            <div>即时</div>
          </div>
        </div>
        <template v-for="(nav, idx) in navList">
          <oddItem class="nav-item" :key="`${nav.id}-${idx}`" :nav="nav" :odds="obj"/>
        </template>
      </div>
    </div>
  </div>
  <div class="empty-page" v-else>
    <img src="../../../assets/images/gaming/empty-game.png" alt="">
    <p>暂无数据！</p>
  </div>
</template>

<script>
import oddItem from './oddItem.vue';

export default {
  name: 'OddsPage',
  components: {
    oddItem
  },
  props: {
    odds: {
      type: Array
    }
  },
  data () {
    return {}
  },
  filters: {
    numToCN(num) {
      // 定义一个数组存储汉字
      const CN_CHARS = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
      // 定义一个字符串存储结果
      let result = "";
      // 定义一个变量存储位数
      let digit = 0;
      // 使用一个循环遍历数字的每一位
      while (num > 0) {
        // 取出数字的最后一位
        let last = num % 10;
        // 根据位数和值拼接汉字
        if (digit === 0) {
          // 个位
          result = CN_CHARS[last] + result;
        } else if (digit === 1) {
          // 十位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加十和对应的汉字
            result = "十" + CN_CHARS[last] + result;
          }
        } else if (digit === 2) {
          // 百位
          if (last === 0) {
            // 如果是零，只加零
            result = CN_CHARS[last] + result;
          } else {
            // 如果不是零，加百和对应的汉字
            result = "百" + CN_CHARS[last] + result;
          }
        }
        // 将数字除以10，去掉最后一位
        num = Math.floor(num / 10);
        // 将位数加一
        digit++;
      }
      // 返回结果
      return result;
    }
  },
  computed: {
    isEmpty () {
      return this.odds.length < 1
    },
    navList () {
      const nav = []
      const gameCount = Math.max.apply(Math, this.odds.map(item => item.game_count))
      const type = Array.from(new Set(this.odds.map(item => item.type)))
      if (type.includes(101)) {
        nav.push({
          id: 101,
          name: '全场胜负'
        })
      }
      if (type.includes(102)) {
        nav.push({
          id: 102,
          name: '全场让分'
        })
      }
      if (type.includes(1001)) {
        for (let i = 1; i <= gameCount; i++) {
          nav.push({
          id: 1001,
            name: i
          })
        }
      }
      return nav
    },
    oddsList () {
      const list = {}
      this.odds.forEach(item => {
        if (list[item.company_name || item.company]) {
          list[item.company_name || item.company].push(item)
        } else {
          list[item.company_name || item.company] = [item]
        }
      })
      return list
    }
  }
}
</script>

<style lang="less" scoped>
.table-title {
  display: flex;
  height: 40px;
  background: #F7F7F7;
  line-height: 40px;
  font-size: 16px;
  color: #C0A3A6;
  > div {
    box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.25), inset -1px 0px 0px 0px rgba(0,0,0,0.25), inset 0px 1px 0px 0px rgba(0,0,0,0.25);
  }
  .name {
    width:122px;
    text-align: center;
    box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.25), inset -1px 0px 0px 0px rgba(0,0,0,0.25), inset 1px 0px 0px 0px rgba(0,0,0,0.25), inset 0px 1px 0px 0px rgba(0,0,0,0.25);
  }
  .nav-item {
    flex: 1;
    text-align: center;
  }

}
.odd-item {
  display: flex;
  height: 60px;
  font-size: 14px;
  box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.25);
  background: #F7F7F7;
  &:nth-child(odd) {
    background: #fff;
  }
  .name {
    width:122px;
    line-height: 60px;
    box-shadow: inset 0px 0px 0px 0px rgba(0,0,0,0.25), inset -1px 0px 0px 0px rgba(0,0,0,0.25), inset 1px 0px 0px 0px rgba(0,0,0,0.25);
    display: flex;
    .company {
      width: 71px;
      text-align: center;
      box-shadow: inset 0px 0px 0px 0px rgba(0,0,0,0.25), inset -1px 0px 0px 0px rgba(0,0,0,0.25), inset 0px 0px 0px 0px rgba(0,0,0,0.25);
    }
    .type {
      display: flex;
      flex-direction: column;
      width: 50px;
      text-align: center;
      > div {
        flex: 1;
        line-height: 30px;
        &:first-child {
          box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.25), inset 0px 0px 0px 0px rgba(0,0,0,0.25);
        }
      }
    }
  }
  .nav-item {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0), inset -1px 0px 0px 0px rgba(0,0,0,0.25);
    > div {
      flex: 1;
      align-items: center;
      display: flex;
      .num {
        flex: 1;
        text-align: center;
        &.grey {

          color: #705B5D;
        }
      }
    }
  }
}
.empty-page {
  img {
    display: block;
    width: 50%;
    margin: 80px auto;
  }
  p {
    text-align: center;
    font-size: 16px;
    position: relative;
    top: -150px;
  }
}
</style>
